<html>
    <head>
        <meta name="robots" content="noindex">
    </head>

    <body>
        <div class="internacion">

            <div class="bloque">
                <div class="subtitulo-azul">Admisión de Internaciones — Contacto</div>
                Teléfono: 0221 412-9400, internos 1526 | 1527 | 1528 <br>
                WhatsApp (solo mensajes): 221 523-1434 <br>
                Mail: admisiones@hospitalespanol.org.ar
            </div>

            <h3 class="titulo-seccion">1. Información para tu Internación Programada</h3>
            <div class="bloque">
                <div class="subtitulo-azul">Turnos y documentación en Admisión de Internaciones.</div>
                Si tenés una cirugía programada, el primer paso es acercarte al sector de Admisión de
                Internaciones con la siguiente documentación:
                <ul>
                    <li>Orden de internación</li>
                    <li>DNI</li>
                    <li>Carnet de obra social</li>
                    <li>Estudios previos (consultar)</li>
                </ul>
                El personal de Admisión de Internaciones, realizará las gestiones correspondientes y te
                asignará los turnos para tus estudios prequirúrgicos.
            </div>

            <h3 class="titulo-seccion">Estudios pre quirúrgicos</h3>
            <div class="bloque">
                <ol>
                    <li>
                        <b class="azul">Electrocardiograma: Se asignará el turno en Admisión de Internaciones.</b>
                    </li>
                    <li>
                        <b class="azul">Rutina de Laboratorio</b> <br>
                        Extracciones: lunes a sábados desde las 7:00hs. <br>
                        - Ayuno previo de 8 a 12hs. <br>
                        - Primera orina de la mañana (si se indica). <br>
                        Contacto - Línea directa: 0221 412 9440 | WhatsApp: 221 420 0794
                    </li>
                    <li>
                        <b class="azul">Hemostasia Básica | Grupo y Factor</b> <br>
                        Extracciones: lunes a sábados desde las 7:00hs. <br>
                        - Ayuno previo de 3 horas (grasas y lácteos). <br>
                        Contacto - WhatsApp: 221 504 7019 | Mail: hematologia@hospitalespanol.org.ar
                    </li>
                    <li>
                        <b class="azul">Placa de Tórax (excepto embarazadas)</b> <br>
                        Por orden de llegada: lunes a viernes de 8:00 a 20:00hs. | Sábados de 8:00 a 13:00hs. <br>
                        Contacto - WhatsApp: 221 476 9962
                    </li>
                </ol>
                <ul>
                    <li>
                        <b class="azul">¿Necesitás un accesorio/prótesis para tu cirugía?</b> <br>
                        Comunicate con tu médico con 48 horas de anticipación para confirmar que la provisión
                        del accesorio/prótesis esté asegurada.
                    </li>
                    <li>
                        <b class="azul">¿Tomás medicación crónica?</b> <br>
                        Informáselo a tu médico y no te olvides de traerla.
                    </li>
                    <li>
                        <b class="azul">Consultá por nuestras Habitaciones Premium</b> (sujeto a disponibilidad)
                    </li>
                </ul>
            </div>

            <h3 class="titulo-seccion">2. Preparación para el día de la cirugía</h3>
            <div class="bloque">
                <ul>
                    <li><b class="azul">Ayuno:</b> presentate con 12 horas de ayuno previo.</li>
                    <li><b class="azul">Baño:</b> bañate dentro de las dos horas previas a la cirugía.</li>
                    <li><b class="azul">Uñas:</b> cortalas al ras, sin lastimar la piel (quitar el esmalte si están pintadas).</li>
                    <li>
                        <b class="azul">Si tu cirugía incluye la colocación de un implante:</b> bañate con jabón
                        antiséptico los dos días previos y dos horas antes de la cirugía.
                    </li>
                </ul>
                <p class="resaltado-gris">
                    Solicitamos que te presentes en el Hospital sin accesorios ni elementos personales, como
                    alianzas o bijouterie.
                </p>
                <div class="subtitulo-azul">¿Cómo hacer el baño previo?</div>
                Humedecé todo el cuerpo con abundante agua y lavá con jabón antiséptico o jabón neutro
                nuevo. Hacé hincapié en la cabeza (cabello, cuello, boca), axilas, ombligo, uñas de pies y
                manos, ingle y zona perineal. Enjuagá y secá con más cuidado de lo habitual.
            </div>

            <h3 class="titulo-seccion">3. El día de tu internación</h3>
            <div class="bloque">
                <ul>
                    <li>Vení acompañado/a, sin excepción.</li>
                    <li>
                        Vas a recibir la documentación con las Normas de Funcionamiento Interno
                        (Reglamento) y los Consentimientos Informados.
                    </li>
                </ul>
                <p class="resaltado-gris">
                    Internación de urgencia: se debe presentar, sin excepción, el DNI y el carnet afiliatorio de la
                    obra social.
                </p>
                <ul>
                    <li>No uses perfume, desodorante, talco, maquillaje ni otros cosméticos. Colocate ropa limpia.</li>
                    <li>
                        Antes de ingresar al quirófano, personal de Enfermería te va a dar el equipo de ropa
                        quirúrgica (botas, bata, gorro y tapaboca). Vas a tener que quitarte toda tu ropa, incluida
                        la ropa interior.
                    </li>
                    <li>
                        Si usás prótesis dentaria (parcial o total), ocular y/o auditiva, dejala con un familiar o
                        acompañante antes de ser trasladado/a al quirófano.
                    </li>
                    <li>No suspendas ningún medicamento que tomes habitualmente, excepto por indicación médica.</li>
                    <li>
                        Según el tipo de cirugía, y si tu médico lo indica, se va a realizar el rasurado
                        correspondiente.
                    </li>
                </ul>
            </div>

            <div class="bloque">
                <div class="subtitulo-azul">Donar sangre es donar una oportunidad de vida</div>
                Dato orientativo - Cantidad de dadores de sangre sugerida según el tipo de cirugía:
                Cirugía General (2) | Cirugía Cardiovascular (12) | Cardiotorácica (4) | Reparación de
                Aneurisma (6) | ByPass Coronario (4) | Ortopedia y Traumatología (4) |
                Obstetricia/Ginecología (4) | Urología (2) | Nefrectomía Radical (3) | Trasplante Renal (2). <br>
                <b><i>Una donación puede ayudar a varias personas y marcar la diferencia cuando más se necesita.</i></b>
                <br><br>
                <b class="azul">Centro Regional de Hemoterapia, ubicado en calle 71 entre 26 y 27.</b>
            </div>

            <h3 class="titulo-seccion">4. Horarios de visita</h3>
            <div class="bloque">
                <p>
                    <b>Habitaciones</b> (1 visita por paciente) <br>
                    <span class="check">9.00 a 11.00hs</span> <br>
                    <span class="check">16.00 a 19.00hs</span>
                </p>
                <p>
                    <b>UCO – Unidad de Cuidados Cardiovasculares</b> (2 visitas por paciente) <br>
                    <span class="check">12.30 a 13.00hs (con informe médico)</span>
                </p>
                <p>
                    <b>UTI – Unidad de Terapia Intensiva</b> (2 visitas por paciente) <br>
                    <span class="check">Informe médico: a partir de las 11.30hs</span> <br>
                    <span class="check">12.00 a 12.30hs</span> <br>
                    <span class="check">20.00 a 20.30hs (sin informe)</span>
                </p>
                <p>
                    <b>En las salas de espera de las unidades cerradas solo pueden permanecer 2 visitas por
                    paciente.</b> <br>
                    El resto deberá esperar su turno de ingreso en el hall de entrada de planta baja.
                </p>
            </div>

            <h3 class="titulo-seccion">5. El egreso</h3>
            <div class="bloque">
                <ul>
                    <li>
                        <b class="azul">Alta médica:</b> el médico de cabecera indica formalmente el alta, para que
                        te puedas retirar del Hospital.
                    </li>
                    <li>
                        <b class="azul">Saldos pendientes:</b> acercate al sector de Admisión de Internaciones,
                        donde te indicarán cómo proceder.
                    </li>
                    <li>
                        <b class="azul">Internaciones particulares o de asociados:</b> el paciente o su familiar
                        deben pasar por APHE (Asociación de Profesionales de Hospital Español), ubicada en planta
                        baja, frente a la Central de Turnos.
                    </li>
                </ul>
            </div>

        </div>
    </body>

</html>
